<!--
    描述：认证窗口
    时间：2022-06-22
    Created by zwh
-->
<template>
  <div class="initiate-cert-page">
    <div v-if="stepIndex == 1" class="dv-step1">
      <el-form :model="objectForm"
               :rules="objectFormRules"
               ref="objectForm"
               label-width="170px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号码" label-width="85px"
                          prop="mobileNo"
                          :show-message="false">
              <el-input v-model="objectForm.mobileNo" placeholder="请输入手机号"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="" label-width="85px">
              提示：请确保手机号为本人所有，否则无法完成注册
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="" label-width="85px" prop="veryCode" :show-message="false">
              <!--
              <el-input v-model="objectForm.veryCode"
                        autocomplete="off"></el-input>

              <el-input v-model="objectForm.veryCode" placeholder="请输入该手机号收到的验证码" autocomplete="off">
                <template slot="append" class="very-code-btn-normal">{{vertBtnTxt}}</template>
              </el-input>
              -->
              <el-row>
                <el-col :span="17">
                  <el-input v-model="objectForm.veryCode"
                            autocomplete="off"></el-input>
                </el-col>
                <el-col :span="7">
                  <el-button @click="getVeryCode" :type="veryBtnDisabled ? '':'primary'" class="w100" :class="{'btn-blue':!veryBtnDisabled, 'very-code-btn-disabled':veryBtnDisabled}" :disabled="veryBtnDisabled">{{veryBtnTxt}}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-if="stepIndex == 2" class="dv-step2"><!-- @click="nextStep"-->
      <div class="dv-tip">
        请拿出手机，打开微信或支付宝扫描下面的二维码，在移动端完成会员注册认证过程。
      </div>
      <div class="dv-qr-code">
        <!--
        <img src="http://172.16.0.153/huangfeng/ngsyh/images/%E5%BE%AE%E4%BF%A1%E7%99%BB%E5%BD%95/u924.png" class="img-qr-code"/>
        -->
        <vue-qr :text="qrCodeText" :size="286"></vue-qr>
      </div>
    </div>

    <div v-if="stepIndex == 3" class="dv-step3">
      <div class="dv-tip">
        恭喜您已完成电子签章会员的注册认证！
      </div>

      <div class="dv-suc-tip">
        <el-tag type="info" class="tg-suc-tip">{{ successBtnNum }}</el-tag>&emsp;后将自动关闭弹窗。
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import * as API from 'api/modules/es/member_manage'
export default {
  name: "initiate-certification-dialog",
  components : {
    vueQr,
  },
  data(){
    return {
      //认证步骤序号
      stepIndex : 1,

      objectForm : {
        mobileNo : '',
        veryCode : '',
      },
      objectFormRules : {
        mobileNo: [{ required: true,message: '请输入手机号',	trigger: 'blur',}],
        veryCode: [{ required: true,message: '请输入验证码',trigger: 'blur', }],
      },

      //获取验证码 属性
      veryCodeTimer : null,
      veryBtnDisabled : false,
      veryBtnTxt : '获取验证码',
      veryBtnNum : 60,
      //二维码文本信息
      qrCodeText : '',
      //认证成功 计数
      successBtnNum : 3,
      sucTimer : null,
      //第二步骤，获取用户是否扫码验证 定时器
      step2CallBackLoopTimer : null,
    }
  },
  watch: {
    stepIndex(val){
      if(val == 3) {
        this.sucTimer = setInterval(() => {
          this.successBtnNum--
          if(this.successBtnNum == -1) {
            clearInterval(this.sucTimer)
            this.$emit('on-success')
          }
        }, 1000)
      }
    }
  },
  methods : {
    getVeryCode(){
      let that = this
      that.veryBtnDisabled = true
      that.veryBtnTxt = that.veryBtnNum
      that.veryCodeTimer = setInterval(() => {
        that.veryBtnNum--
        that.veryBtnTxt = that.veryBtnNum
        if (that.veryBtnNum === -1) {
          that.veryBtnTxt = '获取验证码'
          that.veryBtnNum = 60
          that.veryBtnDisabled = false
          clearInterval(that.veryCodeTimer)
        }
      }, 1000)

      //获取 手机验证码
      let param = {
        mobileNo : this.objectForm.mobileNo,
        smsSource : 5,  //发送短信来源1:手机登录 2:修改密码发短信 3:能公社绑定第三方发送验证码 5:e签宝认证
      }
      API.sendSingleSms(param).then(res=>{
        if(res.operationCode == 1) {

        } else {
          this.$message.error("获取验证码失败！");
        }
      })

    },
    // 验证 步骤
    nextStep(){
      if(this.stepIndex == 1) {
        this.$refs.objectForm.validate(valid => {
          if (valid) {
            //验证验证码是否有效
            let param = {
              mobileNo : this.objectForm.mobileNo,
              smsSource : 5,  //发送短信来源1:手机登录 2:修改密码发短信 3:能公社绑定第三方发送验证码 5:e签宝认证
              verifyCode : this.objectForm.veryCode
            }
            API.checkSingleSms(param).then(res=>{
              if(res.operationCode == 1) {
                //发起验证
                this.startValidate()
              } else {
                this.$message.error(res.msg);
              }
            })

          } else {
            //this.$message.warning('请完善必填项!')
          }
        })
      }
      /*
      else if(this.stepIndex == 2) {
        this.resetStep2Timer()
        this.stepIndex++
      }
       */
    },
    startValidate(){
      /*
      this.qrCodeText = "1232312"
      this.stepIndex++
      this.$emit('on-step-index', this.stepIndex)

      //创建用户扫码 请求定时器
      this.initStep2Timer()
      return
       */
      let param = {
        mobileNo : this.objectForm.mobileNo
      }
      API.startValidate(param).then(res=>{
        if(res.operationCode == 1) {
          //验证成功，验证码有效
          this.qrCodeText = res.data.data
          this.stepIndex++
          this.$emit('on-step-index', this.stepIndex)

          //创建用户扫码 请求定时器
          this.initStep2Timer()
        }else {
          this.$message.error(res.data);
          this.initStep2Timer()
        }
      })
    },
    //创建用户扫码 请求定时器
    initStep2Timer(){
      this.step2CallBackLoopTimer = setInterval(() => {
        let param = {
          mobileNo : this.objectForm.mobileNo
        }
        API.getObjectByMobileNo(param).then(res=>{
          if(res.operationCode == 1) {
            if(res.data && res.data.accountId) {
              this.resetStep2Timer()
              this.stepIndex++
            }
          }
        })
      }, 1000)
    },
    //重置2步骤获取 用户是否扫码验证 定时器
    resetStep2Timer(){
      clearInterval(this.step2CallBackLoopTimer)
    },
  },
}
</script>

<style lang="less" scoped>
.initiate-cert-page {
  text-align: center;

  .dv-step1{
    padding: 70px 90px 80px 70px;

    .very-code-btn-normal {
      background: #256CCB;
    }
    .very-code-btn-disabled {
      color: #666666;
    }
  }

  .dv-step2{
    padding: 10px 10px 20px;

    .dv-tip{
      font-size: 16px;
    }

    .dv-qr-code{
      margin-top: 30px;

      .img-qr-code{
        width: 285px;
        height: 286px;
      }
    }
  }

  .dv-step3{
    padding: 70px 90px 80px 70px;
    text-align: left;

    .dv-tip{
      font-size: 18px;
    }

    .dv-suc-tip {
      margin-top: 30px;

      .tg-suc-tip {
        width : 48px;
        height: 24px;
        line-height: 24px;
        color : #666666;
        background: #D7D7D7;
        text-align: center;
      }
    }
  }
}
</style>